import React, { useState } from 'react';

import * as formatters from '../../../utils/formatters';
import useGlobalState from '../../GlobalStateContext';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import useOnce from '../../hooks/useOnce';
import axios from '../../services/MyAxios';

import ChangeLinePriceModal from './ChangeLinePriceModal';

export default function LotteryRules({ url, lotteryDisplaySlug, isPriceEditable }) {
    const { formatPercentage } = formatters;
    const [rules, setRules] = useState([]);
    const { loggedAdmin } = useGlobalState();

    useOnce(async () => setRules((await axios.get(url)).data));

    return (
        <Card title="Lottery Rules">
            <TableDetailsBody>
                <Row label="Start">{rules.start}</Row>
                <Row label="End">{rules.end}</Row>
                <Row label="Stake min">{rules.stake_min}</Row>
                <Row label="Stake max">{rules.stake_max}</Row>
                <Row label="Odds">{formatPercentage(rules.odds)}</Row>
                <Row label="Counts">{rules.counts}</Row>
                <Row label="Numbers per line">{rules.numbers_per_line}</Row>
                <Row label="Total numbers">{rules.total_numbers}</Row>
                <Row label="Ranges">{rules.ranges}</Row>
                <Row label="Line sell price">
                    {`${rules.line_sell_price} ${rules.line_sell_currency_code}`}{' '}
                    {!!isPriceEditable &&
                        loggedAdmin.hasPermission('update lottery_rule') &&
                        !!rules.line_sell_price && (
                            <ChangeLinePriceModal lotteryDisplaySlug={lotteryDisplaySlug} rules={rules} />
                        )}
                </Row>
                <Row label="Payout percent">{formatPercentage(rules.payout_percent)}</Row>
                <Row label="Line buy price">{`${rules.line_buy_price} ${rules.line_buy_currency_code}`}</Row>
                <Row label="Fixed line markup">
                    {rules.fixed_line_markup} {rules.line_buy_currency_code}
                </Row>
                <Row label="Fixed provider line fee">
                    {rules.fixed_line_provider_fee || 0} {rules.line_buy_currency_code}
                </Row>
            </TableDetailsBody>
        </Card>
    );
}
